import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Grommet, Box, Layer, ThemeContext, Image } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import { ApplicationState } from '../store';
import { setError, setMessage, setAcknowledgedCallback } from '../store/Site';
import _ from 'lodash';

const hpeTheme = {
    global: {
        breakpoints: {
            xsmall: {
                value: 599
            },
            medium_small: {
                value: 1024
            },
            medium: {
                value: 1100
            },
            medium_large: {
                value: 1200
            }
        }
    },
    anchor: {
        color: { "dark": "light-1", "light": "brand" },
        hover: {
            extend: { "color": "black" }
        }
    },
    accordion: {
        heading: {
            level: "5"
        }
    },
    checkBox: {
        size: "14px",
        gap: "xsmall"
    },
    tabs: {
        gap: "small",
    },
    radioButton: {
        size: "14px",
        gap: "xsmall"
    },
    select:
    {
        icons: {
            color: "brand"
        }
    }
};

const mapDispatchToProps = {
    setError,
    setMessage,
    setAcknowledgedCallback
}

interface ILayoutProps {
    children?: React.ReactNode;
}

type LayoutProps =
    ILayoutProps
    & ApplicationState // ... state we've requested from the Redux store
    & typeof mapDispatchToProps
    & RouteComponentProps<any>; // ... plus incoming routing parameters

interface ILayoutState {
}

class Layout extends React.PureComponent<LayoutProps, ILayoutState> {
    onErrorAcknowledged = () => {
        this.props.setError(undefined);
        if (this.props.site.acknowledgedCallback) {
            this.props.site.acknowledgedCallback();
            this.props.setAcknowledgedCallback(undefined);
        }
    }

    onMessageAcknowledged = () => {
        this.props.setMessage(undefined);
        if (this.props.site.acknowledgedCallback) {
            this.props.site.acknowledgedCallback();
            this.props.setAcknowledgedCallback(undefined);
        }
    }

    public render() {
        return <Grommet theme={hpe}>
            <ThemeContext.Extend value={hpeTheme}>
                <Box fill>
                    {this.props.site.loading && <Layer background="none">
                        <Box align="center" justify="center" height="xxsmall" width="small">
                            <Image src="images/loader.svg" />
                        </Box>
                    </Layer>}
                    <Box id="everything" className="everything">
                        <Box id="content">
                            <Box id="header" className="header"></Box>
                            <Box id="body" className="body ">
                                <Box id="content-body" className="hpehf-centered-content">
                                    <Box id="main-body" fill >
                                        {this.props.children}
                                    </Box>
                                </Box>
                            </Box>
                            <Box id="footer" className="footer"></Box>
                        </Box>
                    </Box>
                </Box>
            </ThemeContext.Extend>
        </Grommet>
    }
}

export default withRouter(connect(
    (state: ApplicationState) => state, // Selects which state properties are merged into the component's props
    mapDispatchToProps)(Layout as any));
